import { resolveMtnGhanaRegionFromUserIp } from '@/js/mtnGhanaGeo'

const state = {
  size: 0,
  isMobile: false,
  isPortrait: false,
  isWebView: false,
  countryCode: 'US',
  language: 'en',
  /** Ghana IP subdivision mapped for MTN (null when IP is not GH or geo failed) */
  mtnGhanaRegionCode: null,
  /** Raw region string from IP geo (e.g. Greater Accra), when available */
  ipGeoRegionName: null
}

const getters = {}

const actions = {
  track({ commit }) {
    commit('SET_WINDOW_SIZE', window.innerWidth)

    window.addEventListener('resize', () => {
      commit('SET_WINDOW_SIZE', window.innerWidth)
    })
  },
  async hydrateMtnGhanaRegionFromIp({ commit }) {
    const result = await resolveMtnGhanaRegionFromUserIp()
    commit('SET_MTN_GHANA_REGION', {
      mtnGhanaRegionCode: result.mtnGhanaRegionCode,
      ipGeoRegionName: result.regionName
    })
  }
}

const mutations = {
  SET_WINDOW_SIZE(state, width) {
    state.size = width
    state.isMobile = width <= 1024
    state.isPortrait = width <= 768
  },
  SET_WEB_VIEW(state, isWebView) {
    state.isWebView = isWebView
  },
  SET_COUNTRY_CODE(state, countryCode) {
    state.countryCode = countryCode
  },
  SET_LANGUAGE(state, language) {
    state.language = language
  },
  SET_MTN_GHANA_REGION(state, { mtnGhanaRegionCode, ipGeoRegionName }) {
    state.mtnGhanaRegionCode = mtnGhanaRegionCode
    state.ipGeoRegionName = ipGeoRegionName
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
